export const KisiFiltre = {
    karttaHicYapmayanlar: 0,
    karttaDortHaftadirYapmayanlar: 4,
}